import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => createStyles({
  // container: {
  //   display: 'flex',
  //   justifyContent: 'space-between',
  //   fontWeight: 700,
  //   fontSize: 18,
  // },

  totalText: {
    fontSize: 18,
    fontWeight: 700,
    color: '#263245',
    fontFamily: 'Roboto',
  },
  discountText: {
    fontSize: 16,
    color: '#89909A',
    fontFamily: 'Roboto',
    marginBottom: 8,
  },
  periodTipText: {
    marginTop: 5,
    fontSize: 12,
    fontFamily: 'Roboto',
    color: '#89909A',
  },
}), { name: 'CheckoutTotalFieldStyles' });

export default useStyles;
